import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { HigherRevenueTitle } from "../../../../Constants/Constants";
import { H5, LI, UL } from "../../../../AbstractElements";
import CountUp from "react-countup";
import { HigherRevenueData, RevenueGrowth } from "../../../../Data/General/Dashboard/Default";
import ReactApexChart from "react-apexcharts";

const HigherRevenue = () => {
  return (
    <Col xxl="6" lg="8" md="7" sm="6" className="box-col-8e">
      <Card>
        <DashboardCommonHeader title={HigherRevenueTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="revenue-growth">
          <UL className="d-flex align-item-center gap-2 simple-list flex-row">
            <LI><span className="bg-primary"> </span>Offline Sale</LI>
            <LI><span className="bg-secondary"> </span>Online Sale</LI>
          </UL>
          <Row className="align-items-center gy-2">
            <Col lg="9" md="8" className="px-0">
              <div id="revenuegrowth">
                <ReactApexChart options={RevenueGrowth} series={RevenueGrowth.series} type="area" height={314} />
              </div>
            </Col>
            <Col lg="3" md="4">
              {HigherRevenueData.map((item, index) => (
                <div className="growth-details" key={index}>
                  <span>{item.title}</span>
                  <H5>$<CountUp end={item.endValue} className="num-counter" delay={0} /></H5>
                </div>
              ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HigherRevenue;
